import React from "react";
import "../Slider/index.scss";
import people from "../../img/people.png";
import people2 from "../../img/people2.png";

const Slider = () => {
  return (
    <section id="slider">
      <div className="container">
        <h1>Отзывы о нашей школе</h1>

        <div className="slider">
          <div className="slider--block">
            <img src={people} alt="img" />
            <h2>Виктор Александарович</h2>
            <p>
              С радостью оставляю положительной отзыв! Пройдя курс "UX/UI
              Designer с нуля" я с остался полностью доволен, что мой выбор пал
              именно на данную школу. Если вы выберите данную школу - вам
              обеспечена прокачка в выбранной вами области. Всячески рекомендую
              и благодарю!
            </p>
            <span>23.02.2022 г</span>
          </div>
          <div className="slider--block">
            <img src={people2} alt="img" />
            <h2>Алина Татьянован</h2>
            <p>
              Лучшая школа в галактике и место, где я полюбил мир IT !!! Я
              вот-вот стану выпускником Motion Web. За это время мне дали
              фундаментальные знания программирования ( C++, C#, Python ),
              дискретной математики, криптографии, созданию сайтов со сложной
              серверной архитектурой и многим другим важным навыкам.{" "}
            </p>
            <h4>23.02.2022 г</h4>
          </div>
          <div className="slider--block">
            <img src={people} alt="img" />
            <h2>Виктор Александарович</h2>
            <p>
              С радостью оставляю положительной отзыв! Пройдя курс "UX/UI
              Designer с нуля" я с остался полностью доволен, что мой выбор пал
              именно на данную школу. Если вы выберите данную школу - вам
              обеспечена прокачка в выбранной вами области. Всячески рекомендую
              и благодарю!
            </p>
            <span>23.02.2022 г</span>
          </div>
          <div className="slider--block">
            <img src={people2} alt="img" />
            <h2>Алина Татьянован</h2>
            <p>
              Лучшая школа в галактике и место, где я полюбил мир IT !!! Я
              вот-вот стану выпускником Motion Web. За это время мне дали
              фундаментальные знания программирования ( C++, C#, Python ),
              дискретной математики, криптографии, созданию сайтов со сложной
              серверной архитектурой и многим другим важным навыкам.{" "}
            </p>
            <span>23.02.2022 г</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slider;
